import { host } from 'config';

const HowTo = (props) => {
  return `{
      "@type": "HowTo",
      "name": "${props.name}",
      "description": "${props.description}",
      "image": "${host}${props.image}",
      "totalTime": "${props.totalTime}",
      "estimatedCost": {
        "@type": "MonetaryAmount",
        "currency": "${props.estimatedCost.currency}",
        "value": "${props.estimatedCost.value}"
      },
      "supply": {
        "@type": "HowToSupply",
        "name": "${props.supply.name}"
      },
      "tool": [${props.tool.map(
        (t) => `
        {
          "@type": "HowToTool",
          "name": "${t.name}"
        }`
      )}
      ],
      "step": [${props.step.map(
        (s) => `
        {
          "@type": "HowToStep",
          "name": "${s.name}",
          "text": "${s.text}",
          "image": "${host}${s.image}",
          "url": "${s.url}"
        }`
      )}
      ]
    }`;
};

export default HowTo;
